<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="syscalcinfo" :rules="rules" ref="syscalcrule" label-width="120px" class="">
			<el-row>
				<el-col :span="8">
					<el-form-item label="ObjectId" prop="objectid">
						<el-input clearable :disabled="!editok" v-model="syscalcinfo.objectid" maxlength="40"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="PropertyId" prop="propertyid">
						<el-input clearable :disabled="!editok" v-model="syscalcinfo.propertyid" maxlength="40"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="是否默认显示" prop="defaultshow" >
						<el-select style="width: 100%;" :disabled="!editok" v-model="syscalcinfo.defaultshow" placeholder="请选择是否默认显示">
							<el-option v-for="item in statelist" :key="item.code" :label="item.name" :value="item.code"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row >
				<el-col :span="8">
					<el-form-item label="点位名称" prop="name">
						<el-input clearable :disabled="!editok" v-model="syscalcinfo.name" maxlength="40"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="单位" prop="unit">
						<el-input clearable :disabled="!editok" v-model="syscalcinfo.unit" maxlength="40"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="排序" prop="idx">
						<el-input-number style="width: 100%;" :disabled="!editok" v-model="syscalcinfo.idx" :precision="2" :min="0" :max="999" label="排序"></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="计算公式" prop="func">
						<el-input type="textarea" :rows="2" clearable :disabled="!editok" v-model="syscalcinfo.func" ></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
			<el-button v-show="editok" plain @click="closeDlg">取消</el-button>
			<el-button v-show="editok" type="primary" @click="saveSysCalc">保存</el-button>
		</div>
		
	</div>
</template>

<script> 
	import { addCalcPoint, editCalcPoint } from '/static/apiUrl.js'
	export default {
		name : 'CalcDetail',
		data() {
			return {
				editok: false,
				disabled_cord: false,
				syscalcinfo : {
					id: "",
					objectid: "",
					name : '',
					propertyid: "",
					idx: "",
					defaultshow : '',
					func : '',
					unit : ''
				},
				statelist : [
					{
						code : 'Y',
						name : '显示'
					},
					{
						code : 'N',
						name : '不显示'
					}
				],
				rules:{
					name: [
						{ required: true, message: '请输入名称', trigger: 'blur' }
					],
					objectid: [
						{ required: true, message: '请输入ObjectId', trigger: 'blur' }
					],
					propertyid: [
						{ required: true, message: '请输入PropertyId', trigger: 'blur' }
					],
					func: [
						{ required: true, message: '请输入计算公式', trigger: 'blur' }
					],
					
				},
				
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			selectedcalc: {
				type: Object,
				required: false
			},
			add : {
				type : Boolean,
				required : false,
				default : false,
			}
		},
		watch: {
			add : {
				immediate: true,
				handler(newVal) {
					if(newVal == true){
						this.editok = true
					}else{
						this.editok = false
					}
				}
			},
			selectedcalc: {
				immediate: true,
				handler(newVal) {
					if(newVal != null){
						this.syscalcinfo.id = newVal.id
						this.syscalcinfo.objectid = newVal.objectid
						this.syscalcinfo.name = newVal.name
						this.syscalcinfo.propertyid = newVal.propertyid
						this.syscalcinfo.idx = newVal.idx
						this.syscalcinfo.defaultshow = newVal.defaultshow
						this.syscalcinfo.func = newVal.func
						this.syscalcinfo.unit = newVal.unit
					}else{
						this.syscalcinfo.id = ""
						this.syscalcinfo.objectid = ""
						this.syscalcinfo.name = ""
						this.syscalcinfo.propertyid = ""
						this.syscalcinfo.idx = 1
						this.syscalcinfo.defaultshow = ""
						this.syscalcinfo.func = ""
						this.syscalcinfo.unit = ""
					}
				}
			},
		},
		methods: {
			initData(){
				
			},
			closeDlg() {
				this.editok = false
				if(this.add){
					this.$emit("needRefrash",false,false)
				}
			},
			saveSysCalc(){
				this.$refs["syscalcrule"].validate((valid) => {
					if (valid) {
						if(this.syscalcinfo.id != null && this.syscalcinfo.id != ''){  //编辑
							editCalcPoint(this.syscalcinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: "更新成功",
										type: 'success'
									});
									this.$emit("needRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}else{ //新增
							addCalcPoint(this.syscalcinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: "添加成功",
										type: 'success'
									});
									this.$emit("needRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>